// TODO: delete me: reads components from the Sheets-backed NGXS ComponentsState (Components Google Sheet); move to Data Connect.
import { ChangeDetectionStrategy, Component, inject, Inject, signal } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableModule } from '@angular/material/table';
import { Component as JTMSComponent } from '@dis/models';
import { Store } from '@ngxs/store';
import { BuildsSelectors, ComponentsState } from '../../jtms';
import { MatIconModule } from '@angular/material/icon';
import { DatePipe } from '@angular/common';
import { TimeAgoPipe } from '../../pipes';

/** @deprecated Reads components from the Sheets-backed NGXS ComponentsState (Components Google Sheet); move to Data Connect. */
@Component({
  selector: 'lib-traceabilites-table',
  imports: [
    MatIconModule,
    MatTableModule,
    DatePipe,
    TimeAgoPipe,
  ],
  templateUrl: './traceabilites-table.component.html',
  styleUrls: [
    './traceabilites-table.component.css',
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TraceabilitesTableComponent {
  dataSource = signal<JTMSComponent[]>([]);
  displayedColumns: (keyof JTMSComponent | string)[] = [
    'serialNumber',
    'traceNumber',
    'lastNdeDate',
    'ndeTimeAgo',
    'disPoNumber',
  ];

  private store = inject(Store);

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: string,
  ) {
    this.getComponentsFromJobBuilds(data);
  }

  openUrl(url: string) {
    window.open(url, '_blank');
  }

  private getComponentsFromJobBuilds(jobNumber: string) {
    // Get all components from job
    const builds = this.store.selectSnapshot(BuildsSelectors.getByJobNumber(jobNumber));
    this.dataSource.set(
      builds.map(build => this.store.selectSnapshot(ComponentsState.getById(build.serialNumber!)))
    )
  }
}
